import { FormGroup, Checkbox, Callout } from "@blueprintjs/core";
import React from "react";
import { NewScheduleState } from "types";

type Props = {
    days: number[];
    update: (name: keyof NewScheduleState, value: number[]) => void;
};

export default function DayOfWeek({ days, update }: Props) {
    return (
        <Callout>
            <FormGroup label="Days of the Week">
                {dayOfWeekOptions.map((s, idx) => (
                    <Checkbox
                        key={idx}
                        checked={days.includes(s.value)}
                        label={s.label}
                        inline
                        onChange={() => {
                            const set = new Set(days);
                            if (set.has(s.value)) {
                                set.delete(s.value);
                            } else {
                                set.add(s.value);
                            }
                            update("daysOfWeek", Array.from(set));
                        }}
                    />
                ))}
            </FormGroup>
        </Callout>
    );
}
export const dayOfWeekOptions = [
    {
        name: "sunday",
        label: "Sunday",
        value: 0,
        checked: false
    },
    {
        name: "monday",
        label: "Monday",
        value: 1,
        checked: false
    },
    {
        name: "tuesday",
        label: "Tuesday",
        value: 2,
        checked: false
    },
    {
        name: "wednesday",
        label: "Wednesday",
        value: 3,
        checked: false
    },
    {
        name: "thursday",
        label: "Thursday",
        value: 4,
        checked: false
    },
    {
        name: "friday",
        label: "Friday",
        value: 5,
        checked: false
    },
    {
        name: "saturday",
        label: "Saturday",
        value: 6,
        checked: false
    }
];
